module.exports = __webpack_public_path__ + "static/media/licence-fees.b28ba3c0.svg";